import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import {Subscription} from 'rxjs';
import {NgxEzModalService} from '../../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';

@Component({
  selector: 'app-lp-select-modal',
  templateUrl: './lp-select-modal.component.html',
  styleUrls: ['./lp-select-modal.component.scss']
})
export class LpSelectModalComponent implements OnDestroy {
  @Input() maxMatches: number;
  @Input() lps = [
    {minLp: 0, maxLp: 20},
    {minLp: 21, maxLp: 40},
    {minLp: 41, maxLp: 60},
    {minLp: 61, maxLp: 80},
    {minLp: 81, maxLp: 99}
  ];
  @Input() disablePromos = false;
  @Input() lang: string;
  @Input() game: string;

  @Output() selected = new EventEmitter<string | number>();
  private promoModalSub: Subscription;

  title: string;

  constructor(public modalService: NgxEzModalService) { }

  ngOnInit() {
    switch (this.game) {
      case 'valorant':
        this.title = 'select_current_rr';
        break;

      case 'marvel':
        this.title = 'select_current_points';
        break;

      default:
        this.title = 'select_current_lp';
        break;
    }
  }

  ngOnDestroy() {
    if (this.promoModalSub) {
      this.promoModalSub.unsubscribe();
    }
  }

  onSelect(lp) {
    this.selected.emit(lp);
    this.modalService.closeOutletModals('public');
  }
}